import React from 'react';
import PricingHero from '../components/PricingHero/PricingHero';
import PricingCards from '../components/PricingCards/PricingCards';
import './SubscriptionPackages.css';
import { Footer } from '../components';

const SubscriptionPackages = () => {
  return (
    <div className="subscription-packages">
      <PricingHero />
      <PricingCards />
      <Footer />
    </div>
  );
};

export default SubscriptionPackages; 